import { callApi } from './call-api';
import { Tag } from '../models/tag';

let tagsPromise: Promise<Tag[]> | null = null;

export const getTags = (): Promise<Tag[]> => {
  if (tagsPromise === null) {
    tagsPromise = callApi('/tags')
      .then((response: { tags: Tag[] }) => response.tags)
      .catch((err) => {
        tagsPromise = null;
        throw err;
      });
  }
  return tagsPromise;
};

export const getTagsByGroup = async (): Promise<{ meal_type: Tag[]; cuisine: Tag[] }> => {
  const tags = await getTags();
  return {
    meal_type: tags.filter((t) => t.group === 'meal_type'),
    cuisine: tags.filter((t) => t.group === 'cuisine'),
  };
};
